import store from "@/store"

class Epg {
  constructor() {
    this.epgs = null
    this.timeouts = []
  }
  async sync(channels) {
    this.epgs = store.state.live.epgs
    await this.clearTimeouts()

    Object.values(channels).forEach(channel => this.epgs.hasOwnProperty(channel.epg_id) && this.update(channel))
    return true
  }
  async syncChannel(channel) {
    const res = await __.api.get.epgs(channel.epg_id)
    this.epgs[channel.epg_id] = res[channel.epg_id] || []
    await _$.sleep(1000)
    return this.epgs[channel.epg_id].length ? this.update(channel) : false
  }
  async update(channel) {
    try {
      const epg = this.getPrograms(channel.epg_id)
      if (!epg) return false
      channel.epg = epg

      const left = epg.current.end - new Date().getTime()
      this.timeouts.push(setTimeout(() => this.syncChannel(channel), left))
    } catch (err) {
      _$.error(err)
    }
  }
  getPrograms(epg_id) {
    const ts = new Date().getTime()
    let currentProgram = this.epgs[epg_id].find(epg => epg.start <= ts && epg.end >= ts)
    const nextProgram = this.epgs[epg_id].find(epg => epg.start >= ts)

    if (!currentProgram && !nextProgram) return false
    if (nextProgram && !currentProgram) {
      currentProgram = {
        end: nextProgram.start,
        start: ts
      }
    }

    if (currentProgram && !currentProgram.title) currentProgram.title = "N/A"
    if (nextProgram && !nextProgram.title) nextProgram.title = "N/A"

    return {
      current: currentProgram,
      next: nextProgram
    }
  }
  async clearTimeouts() {
    for (const item of this.timeouts) {
      clearTimeout(item)
    }
    this.timeouts = []
    return true
  }
}

export default new Epg()
